import PartialDate from './partial-date';

import type { DateResult, TripType } from './types';

const getDates = (
  tripType: TripType = 'one-way',
  outboundDate?: string | null,
  inboundDate?: string | null,
  selectedOutboundDay?: string | null,
  selectedInboundDay?: string | null,
): DateResult => {
  const isReturn = tripType === 'return';
  const wholeYear = outboundDate === 'wholeyear';
  let outboundMonth: Date | null = null;
  let inboundMonth: Date | null = null;
  let outboundDay: Date | null = null;
  let inboundDay: Date | null = null;

  if (!wholeYear) {
    const parsedOutboundMonth = PartialDate.parse(outboundDate);
    outboundMonth =
      parsedOutboundMonth && parsedOutboundMonth !== 'wholeyear'
        ? parsedOutboundMonth.date
        : null;

    if (selectedOutboundDay) {
      const parsedOutboundDay = PartialDate.parse(
        selectedOutboundDay.substring(0, 10),
      );
      outboundDay =
        parsedOutboundDay && parsedOutboundDay !== 'wholeyear'
          ? parsedOutboundDay.date
          : null;
    }

    if (isReturn) {
      const parsedInboundMonth = PartialDate.parse(inboundDate);
      inboundMonth =
        parsedInboundMonth && parsedInboundMonth !== 'wholeyear'
          ? parsedInboundMonth.date
          : null;

      if (selectedInboundDay) {
        const parsedInboundDay = PartialDate.parse(
          selectedInboundDay.substring(0, 10),
        );
        inboundDay =
          parsedInboundDay && parsedInboundDay !== 'wholeyear'
            ? parsedInboundDay.date
            : null;
      }
    }
  }

  return {
    outboundDay,
    inboundDay,
    outboundMonth,
    inboundMonth,
    tripType,
    wholeYear,
  };
};

export default getDates;
